var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row" }, [
      _c("div", { staticClass: "content-header-left col-md-7 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.trans("efilling.efilling")) +
                  "\n          "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v(_vm._s(_vm.trans("general.home")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/e-filling" } }, [
                      _vm._v(_vm._s(_vm.trans("efilling.efilling")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "breadcrumb-item active" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.trans("efilling.efilling_details")) +
                      "\n              "
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-5 col-12 d-md-block d-none"
        },
        [
          _c("div", { staticClass: "form-group breadcrum-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm ml-1",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/e-filling/create")
                  }
                }
              },
              [
                _c("i", { staticClass: "feather icon-plus" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.trans("efilling.create_efilling")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm ml-1",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/e-filling")
                  }
                }
              },
              [
                _c("i", { staticClass: "feather icon-list" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.trans("efilling.efilling_list")) +
                    "\n        "
                )
              ]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-body" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title float-left mb-0" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.trans("efilling.efilling_details")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.efilling.status === 0 && _vm.hasPermission("approve-e-filling")
            ? _c(
                "button",
                {
                  staticClass: "btn btn-success btn-sm pull-right",
                  on: { click: _vm.approve }
                },
                [
                  _c("i", { staticClass: "feather icon-check" }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.trans("efilling.approve_this_efilling")) +
                      "\n        "
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-4 col-12" }, [
              _vm.attachments.length
                ? _c("div", { staticClass: "card" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "ul",
                        { staticClass: "list-group list-group-vertical-sm" },
                        _vm._l(_vm.attachments, function(attachment) {
                          return _c(
                            "li",
                            {
                              key: attachment.uuid,
                              staticClass: "list-group-item"
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "/view-file/" + attachment.uuid,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "feather icon-file-text"
                                  }),
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(attachment.user_file_type) +
                                      " -\n                      " +
                                      _vm._s(attachment.user_filename) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-8 col-12" }, [
              _c("div", { staticClass: "card" }, [
                _vm.userRole !== "user"
                  ? _c("div", { staticClass: "card-header" }, [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v(
                          "\n                  Personal Income Tax Self Assessment Returns\n                "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _vm.userRole !== "user"
                    ? _c("div", [
                        _c(
                          "ul",
                          { staticClass: "list-group list-group-vertical-sm" },
                          [
                            _c("li", { staticClass: "list-group-item" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.trans("efilling.tax_id")) +
                                  ":\n                      "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.efilling.user.tax_id))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "list-group-item" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.trans("efilling.name")) +
                                  ":\n                      "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.efilling.user.name))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "list-group-item" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.trans("efilling.email")) +
                                  ":\n                      "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.efilling.user.email))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "list-group-item" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.trans("efilling.phone")) +
                                  ":\n                      "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.efilling.user.phone))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "list-group-item" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.trans("efilling.residential_address")
                                  ) +
                                  ":\n                      "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.efilling.user.profile.address)
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("br")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h4", { staticClass: "card-title" }, [_vm._v("Income")]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-group list-group-vertical-sm mb-2" },
                    [
                      _c("li", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.trans("efilling.total_income")) +
                            ":\n                    "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatMoney")(_vm.efilling.total_income)
                            )
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v("Deduction of Income")
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-group list-group-vertical-sm mb-2" },
                    [
                      _c("li", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.trans("efilling.national_housing_fund")
                            ) +
                            ":\n                    "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatMoney")(
                                _vm.efilling.national_housing_fund
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.trans("efilling.national_pension_scheme")
                            ) +
                            ":\n                    "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatMoney")(
                                _vm.efilling.national_pension_scheme
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.trans("efilling.life_insurance")) +
                            ":\n                    "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatMoney")(_vm.efilling.life_insurance)
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.trans("efilling.wht")) +
                            ":\n                    "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm._f("formatMoney")(_vm.efilling.wht))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.trans("efilling.total_deduction")) +
                            ":\n                    "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatMoney")(
                                _vm.efilling.total_deduction
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.trans("efilling.chargable_income")) +
                            ":\n                    "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatMoney")(
                                _vm.efilling.chargable_income
                              )
                            )
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary mr-1",
                        on: { click: _vm.compute }
                      },
                      [
                        _vm._v(
                          "\n                    Compute Tax\n                  "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.efilling.status === 0 &&
                    _vm.hasPermission("approve-e-filling")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            on: { click: _vm.approve }
                          },
                          [
                            _vm._v(
                              "\n                    Approve\n                  "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.isModalVisible
      ? _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: { id: "modal", tabindex: "-1", role: "dialog" }
          },
          [
            _c("div", { staticClass: "modal-dialog modal-lg" }, [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body", attrs: { id: "printable" } },
                  [
                    _c("img", {
                      staticClass: "center-logo",
                      attrs: { src: _vm.getMainLogo, width: "100" }
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("\n            Amount Payable:\n            "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatMoney")(
                              _vm.efilling.payable_tax_amount
                            )
                          )
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: { click: _vm.payNow }
                    },
                    [_vm._v("Pay Now")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.printMe }
                    },
                    [_vm._v("Print")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("Close")]
                  )
                ])
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", [_vm._v("Documents")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Tax Details")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("×")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }